const CONST = {
    'INITIALIZE': 'APP/INITIALIZE', // Set mode looks similar to this
    'SET_MODE': 'APP/SET_MODE',
    'SET_CONFIG': 'APP/SET_CONFIG',
    'FETCH_CONFIG_SUCCESS': 'APP/FETCH_CONFIG_SUCCESS',
    'FETCH_CONFIG_FAILED': 'APP/FETCH_CONFIG_FAILED',

    'SET_SELECTED_ACCOUNT':'ACCOUNTS/SET_SELECTED_ACCOUNT',
    'SET_APPBAR_HEIGHT':'APP/SET_APPBAR_HEIGHT',
    'SET_ACTIVE_MENU':'APP/SET_ACTIVE_MENU',
    'SET_MODAL':'APP/SET_MODAL',
    'SET_LEFT_DRAWER':'APP/SET_LEFT_DRAWER',
    'SET_RIGHT_DRAWER':'APP/SET_RIGHT_DRAWER',

    'FS_MODAL_STATE':'APP/FS_MODAL_STATE',
    'BLOCKUI_STATE':'APP/BLOCKUI_STATE',

    'PREVIEW_THEME':'APP/PREVIEW_THEME',
    'RESTORE_THEME':'APP/RESTORE_THEME',
    'SET_THEME':'APP/SET_THEME',
}

export default CONST;
